import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find } from 'lodash'
import { history } from '../../../../../store'
import Actions from '../../../../../actions'
import Selectors from '../../../../../selectors'
import EditMedicationForm from '../../../../../components/forms/screens/EditMedicationForm'
import { withRouter } from '../../../../../withRouter'

export function DetailsScreen(props) {
  const {
    resident,
    medication,
    router: { params },
    openDiscontinueMedModal,
  } = props

  const editUrl = `/residents/${resident.id}/emar/${params.medication_id}/edit`

  return (
    <div style={styles.wrapper}>
      <EditMedicationForm
        readOnly
        medication={medication}
        resident={resident}
        onConfirm={() => history.push(editUrl)}
        onDelete={() => openDiscontinueMedModal(medication, resident)}
      />
    </div>
  )
}

DetailsScreen.propTypes = {
  emarRoundTimings: PropTypes.array.isRequired,
  medication: PropTypes.object.isRequired,
  openDiscontinueMedModal: PropTypes.func.isRequired,
  resident: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

const styles = {}

const mapStateToProps = (state, props) => {
  return {
    emarRoundTimings: state.data['emar-round-timings'],
    medication: find(Selectors.getResidentMarChart(state, props), {
      id: props.router.params.medication_id,
    }),
    resident: Selectors.getResidentProfile(state, {
      id: props.router.params.id,
    }),
    user: Selectors.getCurrentUserProfile(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  openDiscontinueMedModal: (medication, resident) => {
    dispatch(
      Actions.openModal({
        data: { medication, resident },
        modalId: 'discontinueMed',
      })
    )
    dispatch(Actions.addForm({ formId: 'discontinueMed' }))
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DetailsScreen)
)
